// startup
// Load entry module
__webpack_require__("./Assets/Src/Scripts/frontend.js");
// This entry module used 'exports' so it can't be inlined
